// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    activityStatusResolved: {
        id: 'be.contentSidebar.activityFeed.common.activityStatusResolved',
        defaultMessage: 'RESOLVED',
        description:
            'Indicator of resolved status of Comment or Annotation, visible in Feed Item (in upper-case in supported language)',
    },
});

export default messages;
